var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandingProductBgRihtEffect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 573,
    height: 104,
    viewBox: "0 0 573 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.2998 47.6257H24.2698L24.1499 47.492L2.58984 23.4931L3.16992 22.8472L24.6099 46.7125H72.2998V47.6257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.29 82.3602H208.62V81.447H273.51L267.51 73.6292H201.44L201.35 73.5847L177.15 59.2967H91.21L91.0898 59.1631L69.8298 35.4872L70.4099 34.8413L91.5498 58.3836H177.36L177.45 58.4393L201.65 72.7161H267.89L275.29 82.3602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8198 58.8403L104.8 65.511H169.87L175.6 59.1299L98.8198 58.8403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.07 88.9306L511.49 88.2846L525.28 72.9276H570.44V44.9197L551.08 23.3597V0.34082H551.9V22.981L571.26 44.541V73.8408H525.62L512.07 88.9306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.22 103.252H293.51L293.39 103.118L266.92 73.629H206.22V72.7158H267.26L267.38 72.8495L293.85 102.339H512.88L528.78 84.6317L529.36 85.2776L513.22 103.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.85 70.4888H528.07L525.62 73.2171C525.62 73.2171 570.85 73.7071 570.85 73.3842C570.85 73.0612 570.85 70.4888 570.85 70.4888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.09 91.826C513.686 91.826 514.98 90.3851 514.98 88.6076C514.98 86.8301 513.686 85.3892 512.09 85.3892C510.494 85.3892 509.2 86.8301 509.2 88.6076C509.2 90.3851 510.494 91.826 512.09 91.826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.18 85.3893C526.18 83.6186 527.47 82.1709 529.07 82.1709C530.66 82.1709 531.96 83.6075 531.96 85.3893C531.96 87.16 530.67 88.6077 529.07 88.6077C527.47 88.6077 526.18 87.16 526.18 85.3893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 23.1701C0 21.3994 1.28989 19.9517 2.88989 19.9517C4.48989 19.9517 5.77979 21.3883 5.77979 23.1701C5.77979 24.9408 4.48989 26.3885 2.88989 26.3885C1.28989 26.3885 0 24.9408 0 23.1701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2998 50.2206C73.8959 50.2206 75.1899 48.7796 75.1899 47.0021C75.1899 45.2246 73.8959 43.7837 72.2998 43.7837C70.7037 43.7837 69.4099 45.2246 69.4099 47.0021C69.4099 48.7796 70.7037 50.2206 72.2998 50.2206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.63 98.2852H516.87L513.7 102.795H293.68L289.63 98.2852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.26 85.8009L216.83 93.1287H245.46L238.79 85.7007L210.26 85.8009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.46 85.8009L252.04 93.1287H280.67L274 85.7007L245.46 85.8009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.65 46.8979L572.573 44.7559L566.676 38.1885L564.753 40.3306L570.65 46.8979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.876 55.6299H572.596V44.7385H569.876V55.6299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.84 85.8457H291.02V84.9325H494.5L513.75 63.4839H570.85V64.3971H514.09L494.84 85.8457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.88 85.2222H336.36V86.7256H449.88V85.2222Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingProductBgRihtEffect);
export default __webpack_public_path__ + "static/media/landingProductBGRihtEffect.29e79663463ee1ed90a46fdad4177be3.svg";
export { ForwardRef as ReactComponent };